import { Link } from "react-router-dom";
import { Building2, Mail, Phone, MapPin, Linkedin } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#070A12] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-6">
              <Building2 className="h-7 w-7 text-gold" strokeWidth={1.5} />
              <span className="font-heading font-black text-2xl tracking-tight">
                O Law Ventures<span className="text-gold"> Ltd</span>
              </span>
            </div>
            <p className="text-gray-400 font-light leading-relaxed max-w-sm">
              A UK housing standards compliance specialist — providing expert HHSRS
              hazard reports, compliance advisory and training for landlords,
              managing agents and private tenants.
            </p>
            <div className="flex items-center gap-4 mt-8">
              <a
                href="https://www.linkedin.com/in/osahon-l-67306559"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="O Law Ventures on LinkedIn"
                className="h-10 w-10 flex items-center justify-center border border-white/10 text-gray-400 hover:text-gold hover:border-gold transition-colors duration-300"
              >
                <Linkedin className="h-4 w-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h2 className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-6">
              Navigate
            </h2>
            <ul className="space-y-4">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/hhsrs-guide", label: "HHSRS Guide" },
                { to: "/news", label: "News & Updates" },
                { to: "/shop", label: "Document Shop" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="text-gray-400 hover:text-white transition-colors duration-200 font-light"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-xs text-gray-400 font-light leading-relaxed" data-testid="footer-also-by-us">
              <span className="uppercase tracking-[0.15em] text-gray-400">Also by us</span><br />
              Legalpak — auction legal pack risk analysis
            </p>
          </div>

          <div className="md:col-span-4">
            <h2 className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-6">
              Get in touch
            </h2>
            <ul className="space-y-5">
              <li className="flex items-start gap-3 text-gray-400 font-light">
                <MapPin className="h-5 w-5 text-gold shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>128 City Road,<br />London, EC1V 2NX, United Kingdom</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 font-light">
                <Phone className="h-5 w-5 text-gold shrink-0" strokeWidth={1.5} />
                <a href="tel:+447949300473" className="hover:text-white transition-colors">07949 300473</a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 font-light">
                <Mail className="h-5 w-5 text-gold shrink-0" strokeWidth={1.5} />
                <a href="mailto:enquiries@olawventures.com" className="hover:text-white transition-colors">enquiries@olawventures.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} O Law Ventures Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              data-testid="footer-link-privacy-policy"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-link-terms"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Terms &amp; Conditions
            </Link>
            <p className="text-gray-400 text-sm">
              Registered in England &amp; Wales
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
